import { render, staticRenderFns } from "./DocumentHeaderComponent.vue?vue&type=template&id=21747f3f&scoped=true&"
import script from "./DocumentHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentHeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentHeaderComponent.vue?vue&type=style&index=0&id=21747f3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21747f3f",
  null
  
)

export default component.exports